export default __webpack_public_path__ + "static/media/default-avatar-photo-placeholder-profile-picture-vector.f880c05d.jpg";